module.exports = __webpack_public_path__ + "88ecdb11a680710e56585f7362f51b6e.svg";